import { IconContent } from '@icons';

export const checkmark: IconContent = {
    sm: '<path d="M13.3559 5.3511L6.60059 12.201L2.65503 8.44202L3.34481 7.718L6.57874 10.799L12.6439 4.64893L13.3559 5.3511Z"/>'
};
